import { useEffect, useRef } from "react";

import { useAppSelector } from "app/redux-store-interactions";
import { useExplorerGlobals } from "contexts/explorerGlobals";
import { useHidden } from "contexts/hidden";
import { selectIsApplyingViewpoint } from "slices/explorer";

/**
 * Tells the host that a hide, show, or reset changed the hidden set.
 * Viewpoint apply owns its own notification, so those updates are skipped.
 */
export function useNotifyVisibilityChanged(): void {
    const hiddenIdArr = useHidden().idArr;
    const isApplyingViewpoint = useAppSelector(selectIsApplyingViewpoint);
    const {
        state: { internalEventEmitter },
    } = useExplorerGlobals();
    const ready = useRef(false);
    const applyingRef = useRef(isApplyingViewpoint);
    applyingRef.current = isApplyingViewpoint;

    useEffect(() => {
        if (!ready.current) {
            ready.current = true;
            return;
        }
        if (applyingRef.current || !internalEventEmitter) {
            return;
        }
        void internalEventEmitter.emit("visibilityChanged", { timestamp: Date.now() });
    }, [hiddenIdArr, internalEventEmitter]);
}
